import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  crossColor: PropTypes.string,
  size: PropTypes.number,
};

const DismissCircleIcon = ({
  color = '#1786f6',
  crossColor = '#FFF',
  size = 16,
  id = 'dismiss-circle-icon',
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <defs>
      <path
        d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20z"
        id={`${id}-a`}
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use xlinkHref={`#${id}-a`} />
      </mask>
      <path fill={color} mask={`url(#${id}-b)`} d="M-5 45h50V-5H-5" />
      <g stroke={crossColor} strokeWidth="3" strokeLinecap="round">
        <path d="M14 14l12 12M25.933 14.067L14 26" />
      </g>
    </g>
  </svg>
);

DismissCircleIcon.propTypes = propTypes;

export default DismissCircleIcon;
